import TransactionList from "@/modules/transactions/transaction-list";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/_layout/transactions")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div>
      <TransactionList />
    </div>
  );
}
